import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e4068faa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "cards render-hide-scroll"
};
const _hoisted_2 = {
  class: "nav_select"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1,
  class: "list"
};
const _hoisted_5 = {
  class: "card_list"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "card_items_info"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "title render-font-family"
};
const _hoisted_13 = {
  class: "num"
};
const _hoisted_14 = /*#__PURE__*/_createTextVNode("卡片总张数");
const _hoisted_15 = /*#__PURE__*/_createTextVNode("已选卡片数");
const _hoisted_16 = {
  key: 0,
  class: "deliver-goods-time"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "!", -1));
const _hoisted_18 = {
  key: 1,
  class: "deliver-goods-time"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "!", -1));
const _hoisted_20 = {
  class: "bottom_op"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已选：", -1));
const _hoisted_22 = {
  key: 0,
  class: "select-total"
};
const _hoisted_23 = {
  key: 2,
  class: "card_dialog"
};
const _hoisted_24 = {
  class: "card_detail"
};
const _hoisted_25 = {
  class: "header"
};
const _hoisted_26 = {
  class: "cont"
};
const _hoisted_27 = {
  class: "card_detail_list"
};
const _hoisted_28 = {
  class: "over_card"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_list = _resolveComponent("list");
  const _component_icon = _resolveComponent("icon");
  const _component_CompPay = _resolveComponent("CompPay");
  const _component_CompCards = _resolveComponent("CompCards");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['nav_status', {
      'appNav': $data.env.isModianIos() || $data.env.isModianAndroid()
    }, {
      'wxApp': $data.env.isWxApp()
    }])
  }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nav, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass({
        'active': $data.card_status == item.status
      }),
      key: index,
      onClick: _withModifiers($event => $options.goOrderList(item), ["stop"])
    }, _toDisplayString(item.txt), 11, _hoisted_3);
  }), 128))]), _createElementVNode("div", {
    class: "rule",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goRule && $options.goRule(...args))
  }, "寄存规则")], 2), $data.total == 0 ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $data.loading = $event),
    "immediate-check": "false",
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.card_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "item",
        key: index
      }, [$data.env.isWeibo() ? (_openBlock(), _createElementBlock("h5", _hoisted_6)) : (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(item.name), 1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (cardItem, cardIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['card_items', {
            'has-deliver-goods-time': cardItem.deliver_goods_time || item.relation_type == 1 && cardItem.remarks
          }]),
          key: cardIndex,
          onClick: _withModifiers($event => $options.goCardDetail(cardItem, item.first_relation, item.list.length, item.relation_type), ["stop"])
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: `${_ctx.$imgUrlFilter(cardItem.activity_img_url, 128)}`
        }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(cardItem.activity_name), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", null, [_hoisted_14, _createElementVNode("span", null, _toDisplayString(cardItem.card_num) + "张", 1)]), _createElementVNode("p", null, [_hoisted_15, _createElementVNode("span", null, _toDisplayString($data.numObj[cardItem.activity_id] || 0) + "张", 1)])])])]), item.relation_type == 1 && cardItem.remarks ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString(cardItem.remarks), 1)])) : cardItem.deliver_goods_time ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", null, "预计到货时间：" + _toDisplayString(cardItem.deliver_goods_time) + " 后可选择发货", 1)])) : _createCommentVNode("", true)], 10, _hoisted_8);
      }), 128))]);
    }), 128))])]),
    _: 1
  }, 8, ["loading", "onLoad"])])), _createElementVNode("div", _hoisted_20, [_hoisted_21, $options.card_total > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("span", null, _toDisplayString($options.card_total) + "张", 1), _createElementVNode("div", {
    class: "total-close",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.cancelCheck && $options.cancelCheck(...args))
  }, [_createVNode(_component_icon, {
    name: "cross"
  })])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.open && $options.open(...args), ["stop"]))
  }, "申请发货")]), _createVNode(_component_CompPay, {
    show: $data.deliverVisible,
    card_total: $data.select_total || $options.card_total,
    addressList: $data.addressList,
    addressItem: $data.addressItem,
    first_relation: $data.hasCheckFirst,
    template_info: $data.template_info,
    template_info_list: $data.template_info_list,
    loc: $data.address_loc,
    onChangeIfPayDown: $options.changeIfPayDown,
    onClose: $options.closePay
  }, null, 8, ["show", "card_total", "addressList", "addressItem", "first_relation", "template_info", "template_info_list", "loc", "onChangeIfPayDown", "onClose"]), $data.cardDetailVisible ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createTextVNode(" 卡片详情（" + _toDisplayString($data.card_detail_total) + "张） ", 1), _createElementVNode("i", {
    onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.hideCardDetail && $options.hideCardDetail(...args), ["stop"]))
  })]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.card_detail_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list_item",
      key: index
    }, [_createElementVNode("div", _hoisted_28, [_createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter(item.card_icon, 368)}`
    }, null, 8, _hoisted_29), _createElementVNode("div", _hoisted_30, _toDisplayString(item.level_name), 1)]), _createElementVNode("p", null, _toDisplayString(item.card_name), 1)]);
  }), 128))])])])])) : _createCommentVNode("", true), _createVNode(_component_CompCards, {
    show: $data.showCards,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.showCards = $event),
    second_relation: $data.second_relation,
    activity_name: $data.activity_name,
    activity_id: $data.activity_id,
    select_id: $data.select_id,
    first_relation: $data.hasCheckFirst,
    canChooseMore: $data.canChooseMore,
    card_total: $options.card_total,
    template_info: $data.template_info,
    relation_type: $data.relation_type,
    onUpdateSelectId: $options.updateSelectId,
    onCloseDetail: $options.closeDetail,
    onOpen: $options.open
  }, null, 8, ["show", "second_relation", "activity_name", "activity_id", "select_id", "first_relation", "canChooseMore", "card_total", "template_info", "relation_type", "onUpdateSelectId", "onCloseDetail", "onOpen"])]));
}